import { helper } from "@ember/component/helper"
import { get } from "@ember/object"
import type { Permission } from "@shared/models/permissions"
import { includes, isNil } from "lodash-es"

export function hasPerm(args: [any, Permission]) {
  let [model, perm] = args
  if (isNil(model)) return false
  return includes(get(model, "meta").permissions, perm)
}

const hasPermHelper = helper(hasPerm)
export default hasPermHelper

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "has-perm": typeof hasPermHelper
  }
}
